import React, { useEffect, useState } from 'react'
import { TicketsDataGrid } from './TicketsDataGrid'
import { useDispatch } from 'react-redux'
import * as components from '../../components'
import { showErrorToast } from '../../state/toasts'
import * as rest from '../../services'
import {ICONS, Slider} from "../../components";
import NewTicketWizard from "./NewTicketWizard";
import {Ticket} from "../../api";

interface TicketListPageProps{
     defaultFilters?:Record<string,string|number>
  displayData?:Array<Ticket>
  showOnlyPages?:boolean
  title?:string,
  path?:string,
}
export const TicketListPage = ({
  defaultFilters,
  displayData,
  showOnlyPages,
  title,
  path
}:TicketListPageProps) => {
  const dispatch = useDispatch()
  const [gridData, setGridData] = useState({})
  const [getAPIResults, setGetAPIResult] = useState(null)
  const [errors, setErrors] = useState(null)
  const [hiddenRowKeys, setHiddenRowKeys] = useState([])
  const handleTableChange = (type, { page, sizePerPage }) => {
      console.log(type, { page, sizePerPage })
    const paginationFilters = {
      ...gridData,
      page: page,
      page_size: sizePerPage,
    }
    setGridData(paginationFilters)
  }
  const onFilter = (data) => {
    const searchFilters = data ? { ...data, page: 1 } : gridData
    setGridData({ ...searchFilters })
  }
  const getData = (data) => {
      if (displayData) {
        setGetAPIResult(displayData)
        return
      }
      let finalPayload = { ...gridData, ...data, ...defaultFilters }
      setGetAPIResult(null)
      new rest.TicketService()
        .makeGetRequest(finalPayload)
        .then((response) => {
          setGetAPIResult(response)
        })
        .catch((errors) => {
          dispatch(showErrorToast('Error', 'Could not get tickets list data'))
        })
    }
  useEffect(() => {
    getData()
  }, [gridData])
  return !getAPIResults ? (
    <components.Loading />
  ) : (
    <>
      {errors ? (
        <components.Toast
          dismissTime={10000}
          onDismiss={() => setErrors(null)}
          toastList={[errors]}
          position={'top-right'}
        />
      ) : (
        ''
      )}
      <TicketsDataGrid
        title={title}
        handleTableChange={handleTableChange}
        showOnlyPages={showOnlyPages}
        onFilter={onFilter}
        getData={getData}
        hiddenRowKeys={hiddenRowKeys}
        results={getAPIResults.results}
        pageSize={getAPIResults.page_size}
        count={getAPIResults.count}
        current={getAPIResults.current}
        onError={setErrors}
        onDelete={(item) => {
          setHiddenRowKeys([...hiddenRowKeys, item.url])
        }}
      >
         <Slider
        title={<span>{ICONS.PLUS}</span>}
        header="New Ticket"

      >

        <NewTicketWizard   />
      </Slider>
      </TicketsDataGrid>
    </>
  )
}
